import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EventOriginEnum } from '@app/core/enums/analytics/analytics-value.enum';
import { PermissionEnum } from '@app/core/enums/permissions.enum';
import { AssetGroupInput } from '@app/core/model/entities/asset-group/asset-group';
import { Section } from '@app/core/model/other/field-config';
import { FormStateService } from '@app/shared/components/form-builder/form-state.service';
import { ValidationService } from '@app/shared/services/validation.service';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarManager } from '@services/managers/snackbar.manager';
import { SectionService } from '@services/section.service';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Component({
  selector: 'asset-group-create-modal',
  templateUrl: './asset-group-create-modal.component.html',
  providers: [FormStateService, ValidationService],
  standalone: false
})
export class AssetGroupCreateModalComponent implements OnInit {
  public formId = 'asset_group_creation_dialog';
  protected eventsOrigin = EventOriginEnum.SHEET;
  public Permission = PermissionEnum;
  public permissionsForEdition = [PermissionEnum.CREATE_ASSET_GROUP];
  protected missingRequiredFields$: Observable<{ code: string, label: string }[]>;
  protected form: Section[];

  public formStateService = inject(FormStateService);
  public snackbarManager = inject(SnackbarManager);
  public translate = inject(TranslateService);
  private sectionService = inject(SectionService);
  private destroyRef = inject(DestroyRef);

  public assetGroupInput: AssetGroupInput;

  public ngOnInit(): void {
    this.missingRequiredFields$ = this.sectionService.getSectionsByFormCode(this.formId).pipe(
      tap(sections => this.form = sections),
      map(sections => sections.first()),
      map(section => this.sectionService.missingRequiredFields(section)),
      takeUntilDestroyed(this.destroyRef)
    );

    this.formStateService.saved$
      .pipe(
        tap(({data}) => this.assetGroupInput = data),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }

  /**
   * Data from the filled form.
   * @return Asset group data.
   */
  public getGeneratedObject(): AssetGroupInput {
    return this.assetGroupInput;
  }
}

